import {PracticeApptReasonSpecialty, VisibilityConfig} from "../../src/_services/types";
import {apptReasonEntityCodesToHide} from "../../src/constants/reasonCodes";

const isVisibilityConfigAcceptable = (visibilityConfig?: VisibilityConfig): boolean =>
  !visibilityConfig || !visibilityConfig.providerOnly;

export const isReasonDiscoverable = (apptReason: {
  sortIndex?: number;
  practiceApptReasonSpecialties: PracticeApptReasonSpecialty[];
  code: string;
  name: string;
}): boolean => {
  try {
    const isNotHiddenByCode = !apptReasonEntityCodesToHide.includes(apptReason.code);
    const hasValidSpecialty = apptReason.practiceApptReasonSpecialties.some(({visibilityConfig}) =>
      isVisibilityConfigAcceptable(visibilityConfig),
    );
    const forProviders = /(C4B|flow\shealth|cancel|referral)/gi.test(apptReason.name);

    return hasValidSpecialty && isNotHiddenByCode && !forProviders;
  } catch {
    return false;
  }
};
